// extracted by mini-css-extract-plugin
export var dividerLine = "_70-3";
export var itemImage = "_70-9";
export var lightDivider = "_70-4";
export var modalContent = "_70-5";
export var modalContentCompact = "_70-6";
export var productCard = "_70-a";
export var productImage = "_70-b";
export var productImageCompact = "_70-7";
export var productImagePlaceholder = "_70-c";
export var productImagePlaceholderCompact = "_70-8";
export var progressBarBackground = "_70-1";
export var progressBarContainer = "_70-0";
export var progressBarFill = "_70-2";